module.exports = __webpack_public_path__ + "media/Puppy.d35a977a.mp3";